import UtilsSchema from "@repoflow/schema/utils";
import PageConfigSchema from "@common/schema/page-config";

import FieldsSchema, {
  orgId,
  siteId,
  title,
  config,
  locales,
  defaultLocale,
  translations,
  redirects,
  blog,
  createdAt,
  updatedAt,
} from "./fields";

export default [
  ...UtilsSchema,
  ...PageConfigSchema,
  ...FieldsSchema,
  {
    id: "/Public/Site",
    type: "object",
    properties: {
      orgId,
      siteId,
      title,
      config,
      locales,
      defaultLocale,
      translations,
      redirects,
      blog,
      createdAt,
      updatedAt,
    },
  },
  {
    id: "/Public/Site/Create",
    type: "object",
    properties: {
      siteId,
      title,
    },
    required: ["siteId", "title"],
  },
  {
    // `siteId` is absent on purpose: it is the range key, so an input field for
    // it would read as a rename and would in fact write a second row, leaving
    // the first orphaned and still holding every page and section under it.
    id: "/Public/Site/Update",
    type: "object",
    properties: {
      title,
      config,
      locales,
      defaultLocale,
      translations,
      redirects,
      blog,
    },
    required: ["title"],
  },
];
